import React from "react";
import { direccionTexto } from "@/lib/etapas";
import { activas, misEtapas, fechaHoraEn, misArchivos } from "@/lib/chofer";
import { Button } from "@/components/ui/button";
import { abrirArchivo } from "@/components/chofer/AgregarArchivo";
import { Check, TriangleAlert } from "lucide-react";
import { t } from "@/lib/i18n";
// Fix Q (2026-10-13): pantalla final. «Finish Trip» pasa a «Completed» en verde con el contador Files (N) a la izquierda.
// Si falta un documento obligatorio se ve «Documents pending» y se puede volver a la etapa para adjuntarlo; el cierre administrativo lo espera.
// Si el viaje lo reparten varios choferes, quien termina sus etapas ve «Your steps are done» y NO «Completed» hasta que todas terminen.
export function Completado({ carga, uid, nombreChofer, completa, onFiles, onEtapa }) {
  const ets = activas(carga);
  const nombreEtapa = (c) => ets.find((x) => x.clave === c)?.nombre || c;
  const zonaDe = (c) => ets.find((x) => x.clave === c)?.zona_horaria;
  const mias = misEtapas(carga, uid).filter((e) => e.salida_at);
  const ultima = mias[mias.length - 1] || misEtapas(carga, uid).slice(-1)[0];
  const archivos = misArchivos(carga, uid);
  const propias = carga.docs_faltantes || [];
  const dir = ultima ? direccionTexto(ultima) : "";
  return (
    <section className="bg-white border border-line rounded-[14px] p-4" data-testid="chofer-completado">
      <p className={`eyebrow ${completa ? "!text-ok" : "text-navy-2"}`} data-testid="completado-eyebrow">{completa ? t("Trip completed") : t("Your steps are done")}{t(" · Driver {nombreChofer}", { nombreChofer })}</p>
      {ultima && (
        <>
          <h2 className="mt-1 font-display font-bold text-[28px] leading-tight text-navy-2">{ultima.lugar}</h2>
          {dir && <p className="text-[17px] text-ink">{dir}</p>}
          {carga.chasis_numero && <p className="mt-3 font-bold text-[17px] text-navy-2" data-testid="completado-chassis">{t("Chassis: {chasis_numero}", { chasis_numero: carga.chasis_numero })}</p>}
          <p className="text-[14.5px] text-ink" data-testid="completado-llegada">{t("Arrival: {v0}", { v0: fechaHoraEn(ultima.llegada_at, ultima.zona_horaria) })}</p>
          <p className="text-[14.5px] text-ink" data-testid="completado-fin">{t("Finished: {v0}", { v0: fechaHoraEn(ultima.salida_at, ultima.zona_horaria) })}</p>
        </>
      )}
      <div className="mt-5 grid grid-cols-[1fr_1.6fr] gap-2">
        <Button type="button" variant="outline" data-testid="files-btn" onClick={onFiles} className="h-[52px] text-[16px] font-bold text-navy-2">{t("Files ({length})", { length: archivos.length })}</Button>
        {completa ? (
          <div role="status" data-testid="completed-btn" className="h-[52px] rounded-md bg-ok text-white font-bold text-[16px] flex items-center justify-center gap-1.5"><Check className="h-5 w-5" />{t(" Completed")}</div>
        ) : (
          <div role="status" data-testid="mis-etapas-listas" className="h-[52px] rounded-md border border-ok-line bg-ok-soft text-ok-ink font-bold text-[15px] flex items-center justify-center gap-1.5 text-center leading-tight px-2"><Check className="h-5 w-5 shrink-0" />{t(" Your steps are done")}</div>
        )}
      </div>
      {!completa && <p className="mt-2 text-[13px] text-ink-2" data-testid="completado-parcial">{t("The trip will show Completed when every step is finished.")}</p>}
      <div className="mt-5">
        <p className="eyebrow text-navy-2">{t("Uploaded files")}</p>
        {archivos.length === 0 && <p className="mt-1.5 text-[14px] text-ink-3" data-testid="completado-sin-archivos">{t("No files uploaded yet.")}</p>}
        <ul className="mt-2 space-y-2.5">
          {archivos.map((a) => (
            <li key={a.id}>
              <button type="button" onClick={() => abrirArchivo(a.file_id)} className="text-left w-full" data-testid={`completado-archivo-${a.id}`}>
                <span className="block text-[16px] text-ink">{nombreEtapa(a.etapa)}: {a.nombre}</span>
                <span className="block text-[12.5px] text-ink-2">{t("Uploaded {v0}", { v0: fechaHoraEn(a.subido_at, zonaDe(a.etapa)) })}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      {propias.length === 0 ? (
        <p className="mt-5 text-[15px] font-semibold text-ok" data-testid="docs-completos">{t("All your required documents received.")}</p>
      ) : (
        <div className="mt-5 rounded-xl border-2 border-[#E8B9B8] bg-[#FBEDEC] p-3" data-testid="documents-pending">
          <p className="flex items-center gap-2 font-bold text-danger"><TriangleAlert className="h-5 w-5" />{t(" Documents pending")}</p>
          <p className="text-[13.5px] text-ink-2 mt-0.5">{t("Add them any time. The office closes the load when they arrive.")}</p>
          <ul className="mt-2 space-y-2">
            {propias.map((d) => (
              <li key={d.etapa} className="flex items-center justify-between gap-2">
                <span className="text-[15px] text-ink">{d.nombre} · {d.etapa_nombre}</span>
                <Button type="button" size="sm" data-testid={`pendiente-agregar-${d.etapa}`} onClick={() => onEtapa(d.etapa)} className="h-10">{t("Add")}</Button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
